export const ar = {
  title: "الملف الشخصي",
  pageTitle: "إعدادات الملف الشخصي",
  pageSubtitle: "إدارة معلوماتك الشخصية وتفضيلاتك",
  cardTitle: "المعلومات الشخصية",
  cardDescription: "تفاصيل حسابك",
  saveChanges: "حفظ التغييرات",
  fields: {
    name: {
      label: "الاسم",
      helper: "اسم العرض الخاص بك في جميع أنحاء التطبيق",
      errorRange: "يجب أن يكون الاسم بين 1 و100 حرف",
      errorRequired: "الاسم مطلوب",
      errorMaxLength: "يجب أن يكون الاسم 100 حرف أو أقل",
    },
    email: {
      label: "عنوان البريد الإلكتروني",
      helper: "يُستخدم لتسجيل الدخول والإشعارات",
    },
    role: {
      label: "الدور",
      helper: "تم تعيينه من قبل مسؤول مساحة العمل",
    },
    team: {
      label: "الفريق",
      helper: "تم تعيينه من قبل مسؤول مساحة العمل",
      noTeam: "لا يوجد فريق",
    },
  },
  adminManagedNotice: "يتم إدارة عنوان البريد الإلكتروني والدور وتعيينات الفريق من قبل مسؤول مساحة العمل. اتصل بهم لطلب التغييرات.",
  errorLoadFailed: "فشل تحميل معلومات الملف الشخصي.",
  toastUpdated: "تم تحديث الملف الشخصي",
  toastUpdateFailed: "فشل تحديث الملف الشخصي",
  saved: "تم تحديث الملف الشخصي.",
  saveFailed: "فشل تحديث الملف الشخصي.",
} as const;
